<script setup lang="ts">
defineProps({ blok: Object });
</script>

<template>
  <article class="home">
    <StoryblokComponent
      v-for="item in blok?.Home"
      :key="item._uid"
      v-editable="item"
      :blok="item"
    />
  </article>
</template>
